export const getters = {
  getCustomerEmail ({ customer }) {
    return customer.email
  },
  getCustomer ({ customer }) {
    return customer
  },
  getPurchaser ({ purchaser }) {
    return purchaser
  },
}
